import { useQuery } from '@tanstack/react-query';

import { apiClient } from 'api/ApiClient';

type UseGetPropertiesParams = {
  enabled?: boolean;
};

export function useGetProperties(params: UseGetPropertiesParams = { enabled: true }) {
  const { enabled } = params;

  return useQuery({ queryKey: ['getProperties'], queryFn: () => apiClient.getProperties(), enabled });
}
